/* global google */
import React, { useState, useEffect, useRef } from 'react';
import { GoogleMap, LoadScript, Marker, Polyline } from '@react-google-maps/api';
import { DirectionsRenderer } from '@react-google-maps/api';


// Inside <GoogleMap>


const containerStyle = {
  width: '100%',
  height: '100%',
};

const UserLocationMap = ({ 
  tracking, 
  onCoordinateUpdate, 
  routeCoords, 
  planningMode, 
  onMapClick, 
  plannedRoute,
  startLocation,
  endLocation,
  showNearby,
  setNearbyMarkers,
  nearbyMarkers,
  selectedPlaceType
}) => {
  const [location, setLocation] = useState(null);
  const [previousCoord, setPreviousCoord] = useState(null);
  const [totalDistance, setTotalDistance] = useState(0);
  const mapRef = useRef(null);
  const [userBearing, setUserBearing] = useState(0);
  const [lastPosition, setLastPosition] = useState(null);
  const [mapsReady, setMapsReady] = useState(false);
  // useEffect(() => {
  //   const watch = navigator.geolocation.watchPosition(
  //     (pos) => {
  //       const { latitude, longitude } = pos.coords;
  //       const newCoord = { lat: latitude, lng: longitude };
  //       setLocation(newCoord);
  //       if (tracking) {
  //         onCoordinateUpdate(newCoord);
  //       }
  //     },
  //     (err) => console.error(err),
  //     { enableHighAccuracy: true }
  //   );
    
  //   return () => navigator.geolocation.clearWatch(watch);
  // }, [tracking]);

  
// Add this function to calculate bearing between two points
const calculateBearing = (start, end) => {
  const startLat = start.lat * Math.PI / 180;
  const startLng = start.lng * Math.PI / 180;
  const endLat = end.lat * Math.PI / 180;
  const endLng = end.lng * Math.PI / 180;

  const dLng = endLng - startLng;

  const y = Math.sin(dLng) * Math.cos(endLat);
  const x = Math.cos(startLat) * Math.sin(endLat) - Math.sin(startLat) * Math.cos(endLat) * Math.cos(dLng);

  const bearing = Math.atan2(y, x) * 180 / Math.PI;
  return (bearing + 360) % 360; // Normalize to 0-360 degrees
};
const createAnimatedDirectionalIcon = (bearing, isMoving = false) => {
  return {
    path: 'M12,2A2,2 0 0,1 14,4A2,2 0 0,1 12,6A2,2 0 0,1 10,4A2,2 0 0,1 12,2M21,9V7L15,1H5C3.89,1 3,1.89 3,3V7H9V9H3V19A2,2 0 0,0 5,21H10V19H5V11H9V13H11V7A2,2 0 0,0 9,5H5V3H15V9H21Z', // Custom arrow-like path
    fillColor: isMoving ? '#00BFA6' : '#4285F4',
    fillOpacity: 1,
    strokeColor: '#ffffff',
    strokeWeight: 2,
    scale: 1.5,
    rotation: bearing,
    anchor: { x: 12, y: 12 } // Center the icon
  };
};
const createDirectionalUserIcon = (bearing, isMoving = false) => {
  return {
    path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
    scale: 8,
    fillColor: isMoving ? '#00BFA6' : '#4285F4',
    fillOpacity: 1,
    strokeColor: '#ffffff',
    strokeWeight: 3,
    rotation: bearing,
    // Add pulsing animation effect
    animation: isMoving ? google.maps.Animation.BOUNCE : null
  };
};

// Add this function to create the directional arrow icon
const createDirectionalIcon = (bearing) => {
  return {
    path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
    scale: 6,
    fillColor: '#4285F4',
    fillOpacity: 1,
    strokeColor: '#ffffff',
    strokeWeight: 2,
    rotation: bearing
  };
};

  // useEffect(() => {
  //   const watch = navigator.geolocation.watchPosition(
  //     (pos) => {
  //       const { latitude, longitude } = pos.coords;
  //       const newCoord = { lat: latitude, lng: longitude };
  //       setLocation(newCoord);

  //       if (tracking) {
  //         if (previousCoord) {
  //           const distance = google.maps.geometry.spherical.computeDistanceBetween(
  //             new google.maps.LatLng(previousCoord.lat, previousCoord.lng),
  //             new google.maps.LatLng(newCoord.lat, newCoord.lng)
  //           );

  //           if (distance > 1) { // Avoid micro-movements
  //             setTotalDistance(prev => prev + distance);
  //             onCoordinateUpdate(newCoord);
  //             setPreviousCoord(newCoord);
  //           }
  //         } else {
  //           setPreviousCoord(newCoord);
  //           onCoordinateUpdate(newCoord);
  //         }
  //       }
  //     },
  //     (err) => console.error(err),
  //     { enableHighAccuracy: true, maximumAge: 1000, timeout: 5000 }
  //   );

  //   return () => navigator.geolocation.clearWatch(watch);
  // }, [tracking, previousCoord]);


  useEffect(() => {
  const watch = navigator.geolocation.watchPosition(
    (pos) => {
      const { latitude, longitude } = pos.coords;
      const newCoord = { lat: latitude, lng: longitude };
      
      // Calculate movement bearing if we have a previous position
      if (lastPosition && location) {
        const movementBearing = calculateBearing(lastPosition, newCoord);
        setUserBearing(movementBearing);
        setLastPosition(location); // Update last position
      } else {
        setLastPosition(newCoord);
      }
      
      setLocation(newCoord);

      if (tracking) {
        if (previousCoord) {
          const distance = google.maps.geometry.spherical.computeDistanceBetween(
            new google.maps.LatLng(previousCoord.lat, previousCoord.lng),
            new google.maps.LatLng(newCoord.lat, newCoord.lng)
          );

          if (distance > 1) { // Avoid micro-movements
            setTotalDistance(prev => prev + distance);
            onCoordinateUpdate(newCoord);
            setPreviousCoord(newCoord);
          }
        } else {
          setPreviousCoord(newCoord);
          onCoordinateUpdate(newCoord);
        }
      }
    },
    (err) => console.error(err),
    { enableHighAccuracy: true, maximumAge: 1000, timeout: 5000 }
  );

  return () => navigator.geolocation.clearWatch(watch);
}, [tracking, previousCoord, lastPosition, location]);

  useEffect(() => {
    if (plannedRoute && mapRef.current) {
      const bounds = new window.google.maps.LatLngBounds();
      plannedRoute.routes[0].overview_path.forEach((p) => bounds.extend(p));
      mapRef.current.fitBounds(bounds);
    }
  }, [plannedRoute]);
  
  // Updated to use selectedPlaceType
  useEffect(() => {
    if (location && showNearby && mapRef.current) {
      const service = new window.google.maps.places.PlacesService(mapRef.current);
      
      // Map our custom place types to Google Maps place types
      const placeTypeMap = {
        'park': ['park'],
        'hiking': ['park', 'campground', 'natural_feature'],
        'gym': ['gym'],
        'cafe': ['cafe', 'restaurant'],
        'rest_stop': ['rest_stop', 'gas_station', 'convenience_store']
      };
      
      // Get the appropriate Google Maps place type(s)
      const types = placeTypeMap[selectedPlaceType] || ['park'];
      
      // Need to search for each type separately as Places API only accepts one type per request
      const fetchPlaces = async () => {
        let allResults = [];
        
        for (const type of types) {
          const request = {
            location,
            radius: 3000,  // 3km radius
            type: type
          };
          
          try {
            const results = await new Promise((resolve, reject) => {
              service.nearbySearch(request, (results, status) => {
                if (status === google.maps.places.PlacesServiceStatus.OK) {
                  resolve(results);
                } else {
                  console.warn(`Places request failed for type ${type}:`, status);
                  resolve([]);
                }
              });
            });
            
            allResults = [...allResults, ...results];
          } catch (error) {
            console.error("Error fetching places:", error);
          }
        }
        
        // Remove duplicates (places might appear in multiple categories)
        const uniqueResults = Array.from(new Map(allResults.map(place => 
          [place.place_id, place]
        )).values());
        
        console.log(`Found ${uniqueResults.length} nearby ${selectedPlaceType} locations`);
        setNearbyMarkers(uniqueResults);
      };
      
      fetchPlaces();
    }
  }, [location, showNearby, selectedPlaceType, setNearbyMarkers]);

  // Get appropriate icon for place type
  const getMarkerIcon = (place) => {
    const iconMap = {
      'park': '/park.png',
      'hiking': '/trail.png',
      'gym': '/gym.png',
      'cafe': '/cafe.png',
      'rest_stop': '/rest.png'
    };
    
    // Default to a generic marker if custom icon not available
    return {
      url: iconMap[selectedPlaceType] || '/marker.png',
      scaledSize: new google.maps.Size(30, 30),
    };
  };
  
    useEffect(() => {
    if (totalDistance > 0) {
      const steps = Math.floor(totalDistance / 0.762); // 1 step ≈ 0.762 meters
      console.log(`Distance: ${(totalDistance / 1000).toFixed(2)} km`);
      console.log(`Estimated Steps: ${steps}`);
    }
  }, [totalDistance]);
  return (
    <>

  

    <LoadScript
      libraries={['places', 'geometry']}
      googleMapsApiKey="AIzaSyAf1_BBRbkj36vBHTVvqZ1T4QJfGC9IMsU">
      {location && (
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={location}
          zoom={14}
          onClick={planningMode ? onMapClick : undefined}
      
          onLoad={map => {
            mapRef.current = map;
            setMapsReady(true);
          }}
        >
          {location && <Marker position={location} />}
          
          {plannedRoute && <DirectionsRenderer
            directions={plannedRoute}
          />}
          
          {nearbyMarkers.length > 0 &&
            nearbyMarkers.map((place, idx) => (
              <Marker
                key={`${place.place_id}-${idx}`}
                position={place.geometry.location}
                title={place.name}
                icon={getMarkerIcon(place)}
              />
            ))
          }
            {mapsReady && location && (
                <Marker 
                  position={location} 
                  icon={createDirectionalUserIcon(
                    endLocation 
                      ? calculateBearing(location, endLocation)  // Point toward destination
                      : userBearing,  // Point in movement direction
                    tracking || Boolean(endLocation)  // Show as "moving" when tracking or route planned
                  )}
                  title="Your Location"
                />
              )}
 

          <Polyline
            path={routeCoords}
            options={{
              strokeColor: '#00BFA6',
              strokeOpacity: 0.8,
              strokeWeight: 4,
            }}
          />
        </GoogleMap>
      )}
    </LoadScript>
    </>
  );
};

export default UserLocationMap;